var _circle, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIdleHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    fill: "none",
    viewBox: "0 0 84 84",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 42,
    r: 41.5,
    fill: "#E8E8E8",
    stroke: "#EFF0F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1_2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 35.5,
    fill: "url(#paint0_linear_1_2)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.196 29.906c-1.0662-0.5093-2.2376 0.465-1.9331 1.6064l2.232 8.3401c0.0559 0.2096 0.1722 0.3982 0.3344 0.5423s0.3631 0.2373 0.5779 0.2682l10.943 1.5632c0.3166 0.0443 0.3166 0.5027 0 0.5481l-10.942 1.5622c-0.2148 0.0308-0.4157 0.1241-0.5779 0.2681-0.1622 0.1441-0.2785 0.3327-0.3344 0.5423l-2.2331 8.3445c-0.3045 1.1404 0.8669 2.1147 1.9331 1.6065l23.801-11.347c1.0507-0.5004 1.0507-1.9973 0-2.4988l-23.801-11.346z",
    fill: "#225da4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1_2",
    x: 6,
    y: 6,
    width: 72,
    height: 72,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_1_2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2",
    x1: 15.875,
    x2: 70.832,
    y1: 10.243,
    y2: 72.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F6FA",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDCE0",
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIdleHover);
export default __webpack_public_path__ + "static/media/button-idle-hover.0ec8b7a4eb62955481fedfddeeef8ad7.svg";
export { ForwardRef as ReactComponent };